import { render, staticRenderFns } from "./task_detail.vue?vue&type=template&id=76ac9bb4&scoped=true"
import script from "./task_detail.vue?vue&type=script&lang=js"
export * from "./task_detail.vue?vue&type=script&lang=js"
import style0 from "./task_detail.vue?vue&type=style&index=0&id=76ac9bb4&prod&lang=scss&scoped=true"
import style1 from "./task_detail.vue?vue&type=style&index=1&id=76ac9bb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ac9bb4",
  null
  
)

export default component.exports